import { Link, useNavigate } from 'react-router-dom';
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { Btn, H3, H4, Image, P } from '../../AbstractElements';
import { dynamicImage } from '../../Service';
import {
    CreateAccount,
    DoNotAccount,
    EmailAddress,
    ForgotPassword,
    Href,
    localVariables,
    Password,
    RememberPassword,
    SignIn,
    SignInAccount,
    SignInWith
} from '../../utils/Constant';
import { useState } from 'react';
import { toast } from 'react-toastify';
import SocialApp from './SocialApp';
import { login } from '../../ReduxToolkit/Reducers/Auth/AuthThunk';
import { useAppDispatch } from '../../ReduxToolkit/Hooks';

const Login = () => {
    const dispatch = useAppDispatch();
    const [show, setShow] = useState(false);
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const handleSetCredentials = (e: { email?: string; password?: string }) =>
        setCredentials({ ...credentials, ...e });
    const navigate = useNavigate();

    const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
        try {
            event.preventDefault();
            const resultAction = await dispatch(login(credentials));
            if (login.fulfilled.match(resultAction)) {
                loginSuccess();
            }
        } catch (error) {
            toast.error('Please Enter valid email or password...!');
            console.error(error);
        }
    };

    const loginSuccess = () => {
        const rememberPath = localStorage.getItem(localVariables.REMEMBER_PATH);
        if (rememberPath) {
            navigate(rememberPath);
            localStorage.removeItem(localVariables.REMEMBER_PATH);
            return;
        }
        navigate(`${process.env.PUBLIC_URL}/`);
    };

    return (
        <Container
            fluid
            className="p-0">
            <Row className="m-0">
                <Col
                    xs="12"
                    className="p-0">
                    <div className="login-card login-dark">
                        <div>
                            <div>
                                <Link
                                    className="logo text-center"
                                    to={Href}>
                                    <Image
                                        className="img-fluid for-light"
                                        src={dynamicImage('logo/logoBlack.svg')}
                                        alt="looginpage"
                                    />
                                    <Image
                                        className="img-fluid for-dark"
                                        src={dynamicImage('logo/logoWhite.svg')}
                                        alt="looginpage"
                                    />
                                </Link>
                            </div>
                            <div className="login-main">
                                <Form
                                    className="theme-form"
                                    onSubmit={(e) => handleLogin(e)}>
                                    <H3>{SignInAccount}</H3>
                                    <P>{'Enter your email & password to login'}</P>
                                    <FormGroup>
                                        <Label className="col-form-label">{EmailAddress}</Label>
                                        <Input
                                            type="email"
                                            required
                                            placeholder="Test@gmail.com"
                                            value={credentials.email}
                                            name="email"
                                            onChange={(event) =>
                                                handleSetCredentials({ email: event.target.value })
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className="col-form-label">{Password}</Label>
                                        <div className="form-input position-relative">
                                            <Input
                                                type={show ? 'text' : 'password'}
                                                placeholder="*********"
                                                onChange={(event) =>
                                                    handleSetCredentials({
                                                        password: event.target.value
                                                    })
                                                }
                                                value={credentials.password}
                                                name="password"
                                            />
                                            <div
                                                className="show-hide"
                                                onClick={() => setShow(!show)}>
                                                <span className="show"> </span>
                                            </div>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className="mb-0 form-sub-title">
                                        <div className="checkbox p-0">
                                            <Input
                                                id="checkbox1"
                                                type="checkbox"
                                            />
                                            <Label
                                                className="text-muted"
                                                htmlFor="checkbox1">
                                                {RememberPassword}
                                            </Label>
                                        </div>
                                        <Link
                                            to={`${process.env.PUBLIC_URL}/authentication/forget_password`}>
                                            {ForgotPassword}
                                        </Link>
                                        <div className="text-end mt-3">
                                            <Btn
                                                color="primary"
                                                block
                                                className="w-100">
                                                {SignIn}
                                            </Btn>
                                        </div>
                                    </FormGroup>
                                    <H4 className="text-muted mt-4 or">{SignInWith}</H4>
                                    <SocialApp />
                                    <P className="mt-4 mb-0 text-center">
                                        {DoNotAccount}
                                        <Link
                                            className="ms-2"
                                            to={`${process.env.PUBLIC_URL}/authentication/register_simple`}>
                                            {CreateAccount}
                                        </Link>
                                    </P>
                                </Form>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
